import { AppState } from 'app/store';

export const getCountries = (state: AppState) => state.countries.countries;

export const getUserCountrySelector = (state: AppState) =>
  state.auth.account?.country;
